import { ConfiguracaoDocumentoDTO } from './configuracaoDocumentoDTO';
import { ParametroDossieDTO } from './parametroDossieDTO';

export class SubstitutoMatriculaRapidaDTO{

    id!: number;    
    configuracaoDocumento!: ConfiguracaoDocumentoDTO;
     
}